<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '950px' }"
    header="Formulario Detalle"
    :modal="true"
    class="p-fluid"
    :maximizable="true"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-5">
          <span><strong>TÍTULO: </strong><span class="p-invalid">*</span></span>
          <InputText
            v-model="data_frmpredefinido.titulo"
            required="true"
            placeholder="Título del formulario"
            autofocus
          />
          <small class="p-invalid" v-if="errors.titulo">{{
            errors.titulo[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-5">
          <span
            ><strong>DESCRIPCIÓN CORTA: </strong
            ><span class="p-invalid">*</span></span
          >
          <InputText
            v-model="data_frmpredefinido.descripcion"
            required="true"
            placeholder="Descripción"
          />
          <small class="p-invalid" v-if="errors.descripcion">{{
            errors.descripcion[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>ESTADO: </strong></span>
          <Dropdown
            v-model="data_frmpredefinido.estado"
            :disabled="!data_frmpredefinido.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
        <div class="field col-12 md:col-12">
          <span><strong>CONTENIDO DEL FORMULARIO: </strong></span>
          <quill-editor
            ref="quillEditor"
            :options="opcionesQuill"
            style="height: 400px"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
      />
      <Button
        :label="data_frmpredefinido.id ? 'ACTUALIZAR' : 'GUARDAR'"
        :icon="data_frmpredefinido.id ? 'pi pi-pencil' : 'pi pi-save'"
        class="p-button-primary p-button-lg"
        @click="saveFormulario"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import FrmPredefinidoService from "@/service/FrmPredefinidoService";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
  components: {
    QuillEditor,
  },
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    frmpredefinido: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mostrarModal: this.show,
      data_frmpredefinido: this.frmpredefinido,
      enviado: false,
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
      opcionesQuill: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ header: 1 }, { header: 2 }],
            [{ header: [1, 2, false] }],
            [{ font: [] }],
            [{ align: [] }],
          ],
        },
      },
    };
  },
  frmpredefinidoService: null,
  created() {
    this.frmpredefinidoService = new FrmPredefinidoService();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
      this.enviado = false;
    },

    saveFormulario() {
      this.errors = {};
      this.enviado = true;

      if (!this.data_frmpredefinido.titulo) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "El título es obligatorio",
          life: 3000,
        });
        this.enviado = false;
        return;
      }

      const quillEditor = this.$refs.quillEditor;
      let contenidoParaGuardar = { ops: [] };

      if (quillEditor && quillEditor.getQuill) {
        const delta = quillEditor.getQuill().getContents();
        contenidoParaGuardar = { ops: delta.ops };
      }

      const datos = {
        id: this.data_frmpredefinido.id,
        titulo: this.data_frmpredefinido.titulo,
        descripcion: this.data_frmpredefinido.descripcion || "",
        estado: this.data_frmpredefinido.estado?.value ?? 1,
        contenido: contenidoParaGuardar,
      };

      const promesa = this.data_frmpredefinido.id
        ? this.frmpredefinidoService.updateFrm(datos)
        : this.frmpredefinidoService.sendFrmNew(datos);

      promesa
        .then((response) => {
          if (response && response.errors) {
            this.errors = response.errors;
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Revise los campos",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Éxito",
              detail: response.message,
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al guardar" + (error.message || ""),
            life: 5000,
          });
          this.enviado = false;
        });
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    frmpredefinido: {
      handler(val) {
        this.data_frmpredefinido = { ...val };

        if (val && val.id && val.contenido) {
          this.$nextTick(() => {
            setTimeout(() => {
              const quillEditor = this.$refs.quillEditor;
              if (!quillEditor || !quillEditor.getQuill) return;

              let contenido = val.contenido;

              if (typeof contenido === "string") {
                try {
                  contenido = JSON.parse(contenido);
                } catch (error) {
                  return;
                }
              }

              if (!Array.isArray(contenido)) return;

              const procesado = [];

              contenido.forEach((op) => {
                if (
                  typeof op.insert !== "string" ||
                  !op.insert.includes("\n")
                ) {
                  procesado.push(op);
                  return;
                }

                let buffer = "";

                for (let i = 0; i < op.insert.length; i++) {
                  if (op.insert[i] === "\n") {
                    if (buffer) {
                      const obj = { insert: buffer };
                      if (op.attributes) obj.attributes = { ...op.attributes };
                      procesado.push(obj);
                      buffer = "";
                    }
                    procesado.push({ insert: "\n" });
                  } else {
                    buffer += op.insert[i];
                  }
                }

                if (buffer) {
                  const obj = { insert: buffer };
                  if (op.attributes) obj.attributes = { ...op.attributes };
                  procesado.push(obj);
                }
              });

              quillEditor.getQuill().setText("");
              quillEditor.getQuill().setContents(procesado);
            }, 100);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
